import React, { FC } from "react"

import { Button, Modal } from "@/components"

import { Form, Input } from "antd"
import "./style.less"

interface SendEmailModalProps {
  visible: boolean
  onClose?: () => void
}

const SendEmailModal: FC<SendEmailModalProps> = ({ visible, onClose }) => {
  const handleRemind = () => {

  }

  return (
    <Modal
      visible={visible}
      mask={false}
      onClose={onClose}
      wrapperClassName="modal-wrapper"
    >
      <React.Fragment>
        <div className="email-title">Notify me of payment status changes</div>
        <Form
          className="email-formWrapper"
          autoComplete="off"
        >
          <Form.Item
            layout="vertical"
            label=""
            name="email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input placeholder="Enter your email address" />
          </Form.Item>
        </Form>
        <Button className="email-btn" type="primary" onClick={handleRemind}>Remind</Button>
        <div className="email-desc">When you click on the button, you agree to subscribe to the newsletter</div>
      </React.Fragment>
    </Modal>
  )
}

export default SendEmailModal
